(function () {
  function injectFont() {
    const container = document.querySelector('[data-bv-show="reviews"]');
    if (!container || !container.shadowRoot) return false;

    if (container.shadowRoot.querySelector('#bv-font-override')) return true;

    const style = document.createElement('style');
    style.id = 'bv-font-override';
    style.textContent = `
      * {
        font-family: "Font-1765562304925", sans-serif !important;
      }
    `;

    

    container.shadowRoot.appendChild(style);
    return true;
  }

  const interval = setInterval(() => {
    if (injectFont()) {
      clearInterval(interval);
    }
  }, 300);
})();